// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logistics-screen-layout {
  background-color: oklch(98.4% 0.003 247.858);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 20px;
  padding-right: 20px;
  gap: 0;
  width: 100%;
  height: 100%;
}

.logistics-title-new-booking-div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}

.logistics-top-bar-section-layout {
  display: flex;
  padding: 12px 0px 8px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}

.logistics-top-bar-left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
}

.logistics-left-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}

.logistics-left-section-title-p {
  color: var(--Gray-800, #252b36);
  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.logistics-left-section-subtitle-p {
  color: var(--Gray-700, #414652);

  /* Text sm/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* .logistics-top-bar-right-section {
} */

.logistics-custom-summary-section {
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Blue-25, #edf8ff);
}

.logistics-status-overview-latest-updated {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}

.logistics-order-status-overview-p {
  flex: 1 0 0;
  color: var(--Gray-800, #252b36);

  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.logistics-last-updated-p {
  color: var(--Gray-700, #414652);

  /* Text sm/Medium */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.logisticsSummary {
  /* padding: 0px 10px; */
}

.custom-logistics-grid-class {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

.logistics-delivery-status-tabs-section {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  margin-top: 15px;
}

.logistics-status-tabs-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
}

.input-searchBox {
  display: flex;
  width: 360px;
  height: 40px;
  padding: 10px;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid var(--Gray-300, #d5d7db);
}

.input-searchBox > input {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: var(--Gray-500, #717681);
  text-overflow: ellipsis;

  /* Text sm/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: none;
}

/* ── logistics___ new UI ───────────────────────────────────────── */

/* Header */
.logistics___header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0 8px;
  border-bottom: 1px solid #f1f5f9;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
}

.logistics___scroll-area {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
}

.logistics___scroll-area::-webkit-scrollbar {
  width: 4px;
}

.logistics___scroll-area::-webkit-scrollbar-track {
  background: transparent;
}

.logistics___scroll-area::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.logistics___header-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
}

.logistics___create-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 18px;
  background: #2a71ff;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-family: "Outfit", "Inter", sans-serif;
  white-space: nowrap;
  transition: background 0.15s ease;
}

.logistics___create-btn:hover {
  background: #155eef;
}

/* Summary wrapper */
.logistics___summary-wrapper {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fff;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
}

.logistics___summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.logistics___summary-heading {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  font-family: "Outfit", "Inter", sans-serif;
}

.logistics___summary-updated {
  font-size: 11px;
  color: #64748b;
  font-family: "Outfit", "Inter", sans-serif;
}

/* Summary 6-column grid */
.logistics___summary-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.logistics___summary-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  padding: 10px 8px;
  text-align: center;
  gap: 4px;
}

.logistics___summary-card-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.8;
  font-family: "Outfit", "Inter", sans-serif;
}

.logistics___summary-card-value {
  font-size: 20px;
  font-weight: 700;
  font-family: "Outfit", "Inter", sans-serif;
}

/* Tabs + search row */
.logistics___tabs-search-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.logistics___tabs-container {
  display: inline-flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  padding: 4px;
  gap: 2px;
}

.logistics___tab-btn {
  height: 32px;
  padding: 0 20px;
  border-radius: 14px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Outfit", "Inter", sans-serif;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
  white-space: nowrap;
}

.logistics___tab-btn-active {
  background: #fff;
  color: #0f172a;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);
}

/* Search + filter group */
.logistics___search-filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logistics___search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 256px;
}

.logistics___search-icon {
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  color: #94a3b8;
  pointer-events: none;
  flex-shrink: 0;
}

.logistics___search-input {
  width: 100%;
  height: 40px;
  padding: 0 12px 0 34px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  font-size: 14px;
  color: #0f172a;
  box-shadow:
    0 1px 3px 0 #0000001a,
    0 1px 2px -1px #0000001a;
  font-family: "Outfit", "Inter", sans-serif;
  outline: none;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.logistics___search-input::placeholder {
  color: #94a3b8;
}

.logistics___search-input:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 1px #93c5fd;
}

/* ── Delivery History grid (dh___) ──────────────────────────────── */

.dh___wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dh___card {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}

/* 7-column grid: date | shipmentId | type | provider | route | cost | chevron */
.dh___row {
  display: grid;
  grid-template-columns: 180px 140px 110px 120px 1fr 110px 48px;
  align-items: center;
}

/* Header */
.dh___header-row {
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}

.dh___header-cell {
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  font-family: "Outfit", "Inter", sans-serif;
}

/* Data rows */
.dh___data-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s ease;
}

.dh___data-row:last-child {
  border-bottom: none;
}

.dh___data-row:hover {
  background: rgba(248, 250, 252, 0.5);
}

.dh___cell {
  padding: 12px 16px;
  font-size: 13px;
  font-family: "Outfit", "Inter", sans-serif;
  color: #475569;
  overflow: hidden;
}

.dh___cell-date {
  white-space: nowrap;
  color: #64748b;
}

.dh___cell-id {
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

.dh___cell-provider {
  white-space: nowrap;
  color: #334155;
}

.dh___cell-cost {
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

.dh___cell-right {
  text-align: right;
}

.dh___cell-center {
  text-align: center;
}

/* Type badge */
.dh___badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  font-family: "Outfit", "Inter", sans-serif;
}

/* Route */
.dh___route {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  overflow: hidden;
}

.dh___route-location {
  font-size: 13px;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
}

.dh___route-arrow {
  color: #cbd5e1;
  flex-shrink: 0;
  font-size: 12px;
}

.dh___route-distance {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Chevron button */
.dh___chevron-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.15s ease;
}

.dh___chevron-btn:hover {
  color: #475569;
}

/* Loading / empty state */
.dh___state-row {
  grid-column: 1 / -1;
  padding: 40px 16px;
  text-align: center;
}

.dh___state-text {
  font-size: 14px;
  color: #94a3b8;
  font-family: "Outfit", "Inter", sans-serif;
}

/* Pagination */
.dh___pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 4px 0;
}

.dh___page-btn {
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Outfit", "Inter", sans-serif;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

.dh___page-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.dh___page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.dh___page-info {
  font-size: 13px;
  color: #64748b;
  font-family: "Outfit", "Inter", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/ThirdPartyLogistics/logistics.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;;EAE/B,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;GACG;;AAEH;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;;EAE/B,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;;EAE/B,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;;EAEvB,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,qEAAqE;;AAErE,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C;;;yBAGuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd;;4BAE0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb;;yBAEuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,sEAAsE;;AAEtE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C","sourcesContent":[".logistics-screen-layout {\n  background-color: oklch(98.4% 0.003 247.858);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-left: 20px;\n  padding-right: 20px;\n  gap: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.logistics-title-new-booking-div {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.logistics-top-bar-section-layout {\n  display: flex;\n  padding: 12px 0px 8px 0px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n}\n\n.logistics-top-bar-left-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  flex: 1 0 0;\n}\n\n.logistics-left-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.logistics-left-section-title-p {\n  color: var(--Gray-800, #252b36);\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.logistics-left-section-subtitle-p {\n  color: var(--Gray-700, #414652);\n\n  /* Text sm/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n/* .logistics-top-bar-right-section {\n} */\n\n.logistics-custom-summary-section {\n  display: flex;\n  padding: 12px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n  border-radius: 8px;\n  background: var(--Blue-25, #edf8ff);\n}\n\n.logistics-status-overview-latest-updated {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n}\n\n.logistics-order-status-overview-p {\n  flex: 1 0 0;\n  color: var(--Gray-800, #252b36);\n\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.logistics-last-updated-p {\n  color: var(--Gray-700, #414652);\n\n  /* Text sm/Medium */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.logisticsSummary {\n  /* padding: 0px 10px; */\n}\n\n.custom-logistics-grid-class {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n}\n\n.logistics-delivery-status-tabs-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  margin-top: 15px;\n}\n\n.logistics-status-tabs-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex: 1 0 0;\n}\n\n.input-searchBox {\n  display: flex;\n  width: 360px;\n  height: 40px;\n  padding: 10px;\n  align-items: center;\n  gap: 10px;\n  border-radius: 6px;\n  border: 1px solid var(--Gray-300, #d5d7db);\n}\n\n.input-searchBox > input {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  flex: 1 0 0;\n  overflow: hidden;\n  color: var(--Gray-500, #717681);\n  text-overflow: ellipsis;\n\n  /* Text sm/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border: none;\n}\n\n/* ── logistics___ new UI ───────────────────────────────────────── */\n\n/* Header */\n.logistics___header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0 8px;\n  border-bottom: 1px solid #f1f5f9;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: #fff;\n}\n\n.logistics___scroll-area {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-bottom: 16px;\n}\n\n.logistics___scroll-area::-webkit-scrollbar {\n  width: 4px;\n}\n\n.logistics___scroll-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.logistics___scroll-area::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.logistics___header-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.logistics___create-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 18px;\n  background: #2a71ff;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  white-space: nowrap;\n  transition: background 0.15s ease;\n}\n\n.logistics___create-btn:hover {\n  background: #155eef;\n}\n\n/* Summary wrapper */\n.logistics___summary-wrapper {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #fff;\n  padding: 16px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);\n}\n\n.logistics___summary-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.logistics___summary-heading {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.logistics___summary-updated {\n  font-size: 11px;\n  color: #64748b;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* Summary 6-column grid */\n.logistics___summary-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 8px;\n}\n\n.logistics___summary-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  padding: 10px 8px;\n  text-align: center;\n  gap: 4px;\n}\n\n.logistics___summary-card-label {\n  font-size: 11px;\n  font-weight: 500;\n  opacity: 0.8;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n.logistics___summary-card-value {\n  font-size: 20px;\n  font-weight: 700;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* Tabs + search row */\n.logistics___tabs-search-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.logistics___tabs-container {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #fff;\n  padding: 4px;\n  gap: 2px;\n}\n\n.logistics___tab-btn {\n  height: 32px;\n  padding: 0 20px;\n  border-radius: 14px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n\n.logistics___tab-btn-active {\n  background: #fff;\n  color: #0f172a;\n  font-weight: 600;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);\n}\n\n/* Search + filter group */\n.logistics___search-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.logistics___search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 256px;\n}\n\n.logistics___search-icon {\n  position: absolute;\n  left: 10px;\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  pointer-events: none;\n  flex-shrink: 0;\n}\n\n.logistics___search-input {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px 0 34px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  font-size: 14px;\n  color: #0f172a;\n  box-shadow:\n    0 1px 3px 0 #0000001a,\n    0 1px 2px -1px #0000001a;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  outline: none;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.logistics___search-input::placeholder {\n  color: #94a3b8;\n}\n\n.logistics___search-input:focus {\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 1px #93c5fd;\n}\n\n/* ── Delivery History grid (dh___) ──────────────────────────────── */\n\n.dh___wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dh___card {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n}\n\n/* 7-column grid: date | shipmentId | type | provider | route | cost | chevron */\n.dh___row {\n  display: grid;\n  grid-template-columns: 180px 140px 110px 120px 1fr 110px 48px;\n  align-items: center;\n}\n\n/* Header */\n.dh___header-row {\n  background: #f8fafc;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.dh___header-cell {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* Data rows */\n.dh___data-row {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background 0.1s ease;\n}\n\n.dh___data-row:last-child {\n  border-bottom: none;\n}\n\n.dh___data-row:hover {\n  background: rgba(248, 250, 252, 0.5);\n}\n\n.dh___cell {\n  padding: 12px 16px;\n  font-size: 13px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  color: #475569;\n  overflow: hidden;\n}\n\n.dh___cell-date {\n  white-space: nowrap;\n  color: #64748b;\n}\n\n.dh___cell-id {\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.dh___cell-provider {\n  white-space: nowrap;\n  color: #334155;\n}\n\n.dh___cell-cost {\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.dh___cell-right {\n  text-align: right;\n}\n\n.dh___cell-center {\n  text-align: center;\n}\n\n/* Type badge */\n.dh___badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* Route */\n.dh___route {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.dh___route-location {\n  font-size: 13px;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 110px;\n}\n\n.dh___route-arrow {\n  color: #cbd5e1;\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n.dh___route-distance {\n  font-size: 11px;\n  color: #94a3b8;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Chevron button */\n.dh___chevron-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 4px;\n  border-radius: 4px;\n  transition: color 0.15s ease;\n}\n\n.dh___chevron-btn:hover {\n  color: #475569;\n}\n\n/* Loading / empty state */\n.dh___state-row {\n  grid-column: 1 / -1;\n  padding: 40px 16px;\n  text-align: center;\n}\n\n.dh___state-text {\n  font-size: 14px;\n  color: #94a3b8;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* Pagination */\n.dh___pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 4px 0;\n}\n\n.dh___page-btn {\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.dh___page-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.dh___page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.dh___page-info {\n  font-size: 13px;\n  color: #64748b;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
